module.exports = __webpack_public_path__ + "img/title.5e8a756b.jpg";